import React from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/theme-github';

import styled from 'styled-components';

const StyledAceEditor = styled(AceEditor)`
    #ace_settingsmenu {
        background-color: 'yellow';
    }
`;

export const CodeEditor = React.forwardRef((props, ref) => {
    const { value, onChange, width, height, name, mode } = props;

    const handleChange = newValue => {
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <StyledAceEditor
            ref={ref}
            mode={mode || 'perl'}
            theme="github"
            onChange={handleChange}
            name={name}
            value={value}
            editorProps={{ $blockScrolling: true }}
            width={width}
            height={height}
        />
    );
});
